import { useEffect, useRef } from 'react';

type VisibilityObserverProps = {
  onVisible?: () => void;
  children: React.ReactNode;
};

const VisibilityObserver: React.FC<VisibilityObserverProps> = ({ onVisible, children }) => {
  const observerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const currentRef = observerRef.current;
    if (!currentRef) return;

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            onVisible?.();
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 1
      }
    );

    observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
      observer.disconnect();
    };
  }, [onVisible]);

  return (
    <>
      <div
        ref={observerRef}
        style={{
          width: 0,
          height: 0,
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          visibility: 'hidden'
        }}
      />
      {children}
    </>
  );
};

export default VisibilityObserver;
